import { NgModule } from '@angular/core';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { AutocompleteOptionGroupComponent } from './components/autocomplete-option-group/autocomplete-option-group.component';
import { AutocompleteTriggerDirective } from './directives/autocomplete-trigger.directive';
import { AutocompleteOptionDirective } from './directives/autocomplete-option.directive';
import { AutocompleteOptionGroupTitleDirective } from './directives/autocomplete-option-group-title.directive';
import { AutocompleteStateDirective } from './directives/autocomplete-state.directive';
import { AutocompleteStateTitleDirective } from './directives/autocomplete-state-title.directive';
import { AutocompleteStateSubtitleDirective } from './directives/autocomplete-state-subtitle.directive';

const UI_COMPONENTS = [
  // Components
  AutocompleteComponent,
  AutocompleteOptionGroupComponent,

  // Directives
  AutocompleteTriggerDirective,
  AutocompleteOptionDirective,
  AutocompleteOptionGroupTitleDirective,
  AutocompleteStateDirective,
  AutocompleteStateTitleDirective,
  AutocompleteStateSubtitleDirective,
];

// TODO check module refactor
@NgModule({
  imports: UI_COMPONENTS,
  exports: UI_COMPONENTS,
})
export class AutocompleteModule {}
